<template>
  <div class="app-container">
    <div class="filter-container">
      <el-select class="filter-item" v-model="listQuery.status" placeholder="状态" style="width: 160px" clearable
                 size="small">
        <el-option label="已处理" :value="'processed'"/>
        <el-option label="未处理" :value="'unprocessed'"/>
      </el-select>
      <el-button type="primary" class="filter-item" size="small" @click="handleFilter">搜索</el-button>
    </div>

    <el-table
            v-loading="listLoading"
            :data="list"
            size="small"
            element-loading-text="Loading"
            border
            fit
            highlight-current-row>
      <el-table-column label="ID" width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="昵称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.user?scope.row.user.nickname:"-" }}
        </template>
      </el-table-column>
      <el-table-column label="内容" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>
      <el-table-column label="联系人" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.contact }}
        </template>
      </el-table-column>
      <el-table-column label="图片" min-width="110" align="center">
        <template slot-scope="scope">
          <span v-if="!scope.row.images||scope.row.images.length==0">-</span>
          <el-image v-else
               v-for="(url,key) in scope.row.images"
              style="width: 50px; height: 50px;margin-right: 5px;"
              :src="url"
                    :preview-src-list="[url]"
             :key="key" >  </el-image>
        </template>
      </el-table-column>

      <el-table-column label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 'unprocessed'" type="warning">未处理</el-tag>
          <el-tag v-else-if="scope.row.status === 'processed'" type="success">已处理</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="250" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button type="warning" size="mini" @click="handle(scope.row)" v-if="scope.row.status=='unprocessed'">处理</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
              :current-page="listQuery.page"
              :page-sizes="[10, 20, 30, 50, 100]"
              :page-size="listQuery.limit"
              :total="total"
              background
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
      />
    </div>

    <!-- 详情 -->
    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="60%" :close-on-click-modal="false">
      <el-form ref="form" :rules="rules" :model="form" label-width="180px">
        <el-form-item label="key" prop="key">
          <el-input :disabled="dialogStatus==='update'" type="text" v-model="form.key" clearable />
        </el-form-item>

        <el-form-item label="value" prop="value">
          <el-input type="text" v-model="form.value" clearable />
        </el-form-item>

        <el-form-item label="备注" prop="remark">
          <el-input type="text" v-model="form.remark" clearable />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
    <!-- 详情 -->
  </div>
</template>

<script>
  import request from '@/utils/request'

  export default {
    data() {
      return {
        list: null,
        total: 0,
        listLoading: true,
        listQuery: {
          page: 1,
          limit: 10,
          key: '',
        },
        dialogFormVisible: false,
        dialogStatus: '',
        textMap: {
          create: '新增',
          update: '修改',
        },
        form: {
          id: '',
          key: '',
          value: '',
          remark: '',
        },
        rules: {
          key: [{ required: true, message: 'key不能为空', trigger: 'change' }],
          value: [{ required: true, message: 'value不能为空', trigger: 'change' }],
        },
        btnLoading: false,
      }
    },
    created() {
      this.getList()
    },
    methods: {
      getList() {
        this.listLoading = true
        request({
          url: '/api/backend/feedback/list',
          method: 'get',
          params: this.listQuery,
        }).then(response => {
          this.list = response.data.data
          this.total = response.data.total
        }).finally(()=>{
          this.listLoading = false;
        })
      },
      handleFilter() {
        this.listQuery.page = 1
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.limit = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.listQuery.page = val
        this.getList()
      },
      resetForm() {
        this.form = {
          id: '',
          help_center_type_id: '',
          name: '',
          content: '',
        }
        this.btnLoading = false
      },
      handleCreate() {
        this.resetForm()
        this.dialogStatus = 'create'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['form'].clearValidate() //清除校验结果
        })
      },
      handleUpdate(row) {
        this.resetForm()
        this.form = Object.assign({}, row)
        this.dialogStatus = 'update'
        this.dialogFormVisible = true
        this.$nextTick(() => {
          this.$refs['form'].clearValidate() //清除校验结果
        })
      },
      saveData() {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            this.btnLoading = true
            request({
              url: '/api/backend/keyValue/save',
              method: 'post',
              data: this.form
            }).then(() => {
              this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: '操作成功'
              });
              this.getList();
            }).catch((err) => {
              console.log(err)
              this.btnLoading = false
            }).finally(() => {
              this.btnLoading = false
            })
          }
        })
      },
      handle(row) {
        this.$confirm("确认继续该操作", "提示", {
          type: "warning"
        }).then(() => {
          request({
            url: "/api/backend/feedback/handle",
            method: "post",
            data: {
              ids: [row.id],
            },
            timeout: 10 * 60 * 1000
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功"
            });
          });
        }).catch(() => {
        });
      },
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
